import _sfc_main from "./GenericLazyImageLoader2.mjs";
/* empty css                         */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const GenericLazyImageLoader = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-6ca03afb"]]);
export {
  GenericLazyImageLoader as default
};
//# sourceMappingURL=GenericLazyImageLoader.mjs.map
